'use strict';

const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');

const membershipWidgetsConfig = [{
    id: 'membership-customer-service',
    factory: require('../../membership_customer_service/js/main'),
}, {
    id: 'membership-benefits',
    factory: require('../../membership_benefits/js/main'),
}];

module.exports = withRenderedMain(BaseView.extend({
    initialize() {
        Odigeo._.each(membershipWidgetsConfig, ({factory, id}) => factory.create({id}));
        Odigeo.trigger(`${this.id}:renderOk`, this.options.membershipDTO);
    },
}));
